import { Injectable } from '@angular/core';

@Injectable()
export class ValidationProvider {
	constructor() {}

	isEmailValid(email): boolean {
		const pattern = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
		return pattern.test(email);
	}

	isStringEmpty(string): boolean {
		const emptyString = !string || string.trim() === '';
		return emptyString;
	}

	isModalClosePrevented(input) {
		input.on('keypress', e => {
			const keyCode = e.keyCode || e.which;

			if (keyCode === 13) {
				e.preventDefault();
			}
		});
	}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=nfw9yna8xro!./shared/services/helpers/validation.service.ts